import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActiveBlogs = createAsyncThunk(
  "Blog/FindAllActiveBlog",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Blog/FindAllActiveBlog`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blogs:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getBlogByBlogURL = createAsyncThunk(
  "/Blog/BlogFindByURL",
  async (BlogURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/BlogFindByURL`,
        { BlogURL: BlogURL },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertLead = createAsyncThunk(
  "Website/InsertWebsiteLead",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Website/InsertWebsiteLead`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error inserting lead:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const mobileSubscribe = createAsyncThunk(
  "Tour/SubScribeData",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Tour/SubScribeData`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error subscribing:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function fetchAllBlogs() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Blog/FindAllActiveBlog`, {
      next: { revalidate: 600 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchBlogByURL(BlogURL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Blog/BlogFindByURL`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ BlogURL }),
      next: { revalidate: 300 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}
